import React, { Component } from 'react';
import {
  Button, MenuItem, TextField, Typography, Grid,
  CircularProgress, Paper, CssBaseline, withStyles
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { UpdateSetting, GetSetting, UploadSetting, AddSetting, GetSettingById } from '../../fetchs';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settingId: 0,
      key: '',
      title: '',
      value: '',
      picUrl: "",
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    const key = this.props.match.params.key;
    const settingId = this.props.match.params.settingId;
    if (key) {
      this.loadSetting(key);
    } else {
      this.loadSettingById(settingId);
    }

  }

  loadSetting = (key) => {
    this.setState({ loading: true });
    GetSetting(key)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          key: responseJson.key,
          title: responseJson.title,
          value: responseJson.value,
          settingId: responseJson.settingId,
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  loadSettingById = (settingId) => {
    this.setState({ loading: true });
    GetSettingById(settingId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          key: responseJson.key,
          title: responseJson.title,
          value: responseJson.value,
          settingId: responseJson.settingId,
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    this.state.value = this.state.picUrl !== '' ? this.state.picUrl : this.state.value;
    if (this.state.settingId > 0) {
      UpdateSetting(this.state.settingId, {
        settingId: this.state.settingId,
        key: this.state.key,
        title: this.state.title,
        value: this.state.value
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/settings');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      })
    } else {
      AddSetting({
        settingId: 0,
        key: this.state.key,
        title: this.state.title,
        value: this.state.value
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/settings');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      })
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleSelectFile = event => {
    this.setState({ uploadPic: true });
    UploadSetting(event.target.files[0])
      .then(response => {
        this.setState({ uploadPic: false });
        return response.json();
      }).then(responseJson => {
        this.setState({
          value: responseJson.path
        })
      }).catch(error => {
        console.error(error);
      })
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن تنظیمات جدید
            </Typography>
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item md={7}>
                    {/* <Grid item xs={12} sm={12}> */}
                    {/* <TextField
                        id="standard-key"
                        label="کلید"
                        required
                        fullWidth
                        disabled={this.props.match.params.key ? true : false}
                        className={classes.textField}
                        value={this.state.key}
                        onChange={this.handleChange('key')}
                        margin="normal"
                      /> */}
                    {/* <InputLabel id="label">کلید</InputLabel>
                      <select value={this.state.key} required fullWidth label='کلید' 
                        onChange={this.handleChange('key')} margin="normal" id="standard-key"
                        className="form-control mb-3"
                        >
                        <option >---</option>
                        <option value='ABOUT-US'>درباره ما</option>
                        <option value='APPVERSION'>نسخه نرم افزار موبایل</option>
                        <option value='FOOTER'>فوتر</option>
                        <option value='SLIDER'>سلایدر</option>
                        <option value='CONTACT-US'>تماس با ما</option>
                      </select> */}
                    {/* </Grid> */}
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="standard-select-product-type"
                        select
                        label="کلید"
                        required
                        fullWidth
                        className={classes.textField}
                        value={this.state.key}
                        onChange={this.handleChange('key')}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                      >
                        <MenuItem key='ABOUT-US' value='ABOUT-US'>  درباره ما </MenuItem>
                        <MenuItem key='CONTACT-US' value='CONTACT-US'>  تماس با ما </MenuItem>
                        <MenuItem key='FOOTER' value='FOOTER'>  پاورقی </MenuItem>
                        <MenuItem key='SLIDER' value='SLIDER'> اسلایدر </MenuItem>
                        <MenuItem key='WEBSITE' value='WEBSITE'> وب سایت </MenuItem>
                        <MenuItem key='ADDRESS' value='ADDRESS'> آدرس </MenuItem>
                        <MenuItem key='CALLNUMBER' value='CALLNUMBER'> شماره تماس </MenuItem>
                        <MenuItem key='MOBILE' value='MOBILE'> موبایل </MenuItem>
                        <MenuItem key='INSTA' value='INSTA'> اینستا </MenuItem>
                        <MenuItem key='APPVERSION' value='APPVERSION'> آخرین ورژن نرم افزار </MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="standard-title"
                        label="عنوان"
                        fullWidth
                        className={classes.textField}
                        value={this.state.title}
                        onChange={this.handleChange('title')}
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        id="standard-value"
                        label="توضیحات"
                        fullWidth
                        className={classes.textField}
                        value={this.state.value}
                        onChange={this.handleChange('value')}
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={this.state.loading}
                        onClick={this.handleSave}>ذخیره</Button>
                    </Grid>

                  </Grid>

                  <Grid item md={5}>
                    <div>
                      <input
                        accept="image/*"
                        className={classes.input}
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        onChange={this.handleSelectFile}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          fullWidth
                          variant="contained"
                          component="span"
                          className={classes.button}
                        >
                          ارسال عکس جدید برای محصول
                      </Button>
                        {this.state.uploadPic && <CircularProgress size={24} className={classes.buttonProgress} />}
                      </label>
                    </div>
                    <div>
                      <div className="picParent">
                        {
                          this.state.picUrl ?
                            <img className="fullWidth" src={`http://admin.zistagram.ir/${this.state.picUrl}`} alt={this.state.name} /> :
                            this.state.value ?
                              <img className="fullWidth" src={`http://admin.zistagram.ir/${this.state.value}`} alt={this.state.name} /> :
                              <img className="fullWidth" src={""} alt={this.state.name} />
                        }
                        {/* <img className="fullWidth" src={`http://admin.zistagram.ir/${this.state.value}`} alt={this.state.name} /> */}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Setting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Setting));
